import { render, staticRenderFns } from "./nameID.vue?vue&type=template&id=1725f57a"
import script from "./nameID.vue?vue&type=script&lang=js"
export * from "./nameID.vue?vue&type=script&lang=js"
import style0 from "./nameID.vue?vue&type=style&index=0&id=1725f57a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports